/* eslint-disable react-hooks/rules-of-hooks */

import { AD_UNIT_SECTION } from './types';
import { PAGE_MAPPING } from './constants';

// getPageSectionForAdUnit is used to find the section of website and return a valid advertising ad unit 'section'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPageSectionForAdUnit = (route: string): AD_UNIT_SECTION => {
    const page = Object.entries(PAGE_MAPPING).find((k) =>
        route.startsWith(k[0])
    );

    if (page === undefined) {
        return AD_UNIT_SECTION.UNKNOWN;
    }

    return page[1] as AD_UNIT_SECTION;
};
